/**
 * Thrown by the Form component when client-side validation fails,
 * i.e. the form was never sent to the server.
 */
export class FormValidationError extends Error {
  constructor() {
    super("Form validation failed");
    this.name = "FormValidationError";
  }
}

/**
 * Thrown by the Form component when the server rejects a specific field (e.g. an invalid captcha).
 * The field error is already displayed inline, so callers must not treat the submission as successful.
 */
export class FormServerValidationError extends Error {
  constructor(public readonly elementKey: string) {
    super(`Form field rejected by the server: ${elementKey}`);
    this.name = "FormServerValidationError";
  }
}
